import { render, staticRenderFns } from "./DeclineJournalApproval.vue?vue&type=template&id=ffc8737c&"
import script from "./DeclineJournalApproval.vue?vue&type=script&lang=js&"
export * from "./DeclineJournalApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports